import { renderSlot as _renderSlot, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_ctx.destroyTabWhenInactive)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (_ctx.isActive(_ctx.id))
                ? (_openBlock(), _createElementBlock("div", _mergeProps({ key: 0 }, _ctx.$attrs, { class: "p-2" }), [
                    _renderSlot(_ctx.$slots, "default", {}, undefined, true)
                ], 16))
                : _createCommentVNode("", true)
        ], 64))
        : _withDirectives((_openBlock(), _createElementBlock("div", _mergeProps({ key: 1 }, _ctx.$attrs, {
            class: [{ 'no-height': !_ctx.isActive(_ctx.id) }, "p-2"]
        }), [
            _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ], 16)), [
            [_vShow, _ctx.isActive(_ctx.id)]
        ]);
}
